import React from 'react';
import { useField } from 'react-final-form';

import { CheckOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useCurrentScenarioName } from '@wp-block-builder/editor/hooks';

type Props = {
  value: string | null;
  label: string;
};
function ScenarioMenuItem({ value, label }: Props) {
  const [currentValue, setCurrentScenarioName] = useCurrentScenarioName();
  if (currentValue === value) {
    return (
      <MenuItem>
        <ListItemIcon>
          <CheckOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    );
  }
  return (
    <MenuItem onClick={() => setCurrentScenarioName(value)}>
      <ListItemText inset>{label}</ListItemText>
    </MenuItem>
  );
}

export function DefaultScenarioMenuItem() {
  return <ScenarioMenuItem value={null} label="Default" />;
}

export function CustomScenarioMenuItem({ name }: { name: string }) {
  const { input } = useField<string>(`${name}.name`);
  return <ScenarioMenuItem value={name} label={input.value} />;
}
